import { render } from "./Admins.vue?vue&type=template&id=16f972e0"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__